module.exports = __webpack_public_path__ + "static/TrendingTopics-c-4ee8a303e58f2dc0ee50e6f2c5ffd03c.png";